var GalerieProjets = {
    init:function(){
        $(window).resize(function(){
            GalerieProjets.resize();
        });

        GalerieProjets.resize();
    },
    resize:function(){

       // $(".liste-presse .arrow-container").css({height:$(".liste-presse .illustration").outerHeight()});

        var _carousel = $(".galerie-projets-container .slick-container");

        if (_carousel.hasClass('slick-initialized')) {
            _carousel.slick('unslick');
        }

        //var _slides_to_show = parseInt($("[slider-3-columns]").css("padding-top"));

        var _slides_to_show = 1;
        var els = document.querySelectorAll(".galerie-projets-container");

        Array.prototype.forEach.call(els, function(el) {
            _slides_to_show = parseInt( window.getComputedStyle(el).getPropertyValue("--nbslide"));
        });

        _carousel.slick({
            arrows:true,
            dots:false,
            infinite: true,
            variableWidth:true,
            slidesToShow: _slides_to_show,
            focusOnSelect: true,
            touchThreshold:1000,
            prevArrow:$(".galerie-projets-container .arrow-container.prev .arrow"),
            nextArrow:$(".galerie-projets-container .arrow-container.next .arrow")
        });
    }
}
$(window).load(function(){
    if($(".galerie-projets-container").length){
        GalerieProjets.init();
    }
})